import { axiosInstance } from "../../../utils";

const actions = {
    CREATE_OR_UPDATE_COUPON_REQUESTED: 'CREATE_OR_UPDATE_COUPON_REQUESTED',
    CREATE_OR_UPDATE_COUPON_SUCCEEDED: 'CREATE_OR_UPDATE_COUPON_SUCCEEDED',
    CREATE_OR_UPDATE_COUPON_FAILED: 'CREATE_OR_UPDATE_COUPON_FAILED',

    addOrUpdateCoupon: (data = undefined) => {
        return {
            type: actions.CREATE_OR_UPDATE_COUPON_REQUESTED,
            payload: data
        }},

    createOrUpdateCoupon: async (data = undefined) => {
        let url = `coupons/create`;

        let bodyFormData = new FormData();

        if (data.coupon_percentage) bodyFormData.set('coupon_percentage', data.coupon_percentage );
        if (data.coupon_amount) bodyFormData.set('coupon_amount', data.coupon_amount );
        if (data.limit) bodyFormData.set('limit', data.limit);

        if (data.item_ids) bodyFormData.set('item_ids', JSON.stringify(data.item_ids));
        if (data.brand_path) bodyFormData.set('brand_path', data.brand_path);
        if (data.category_path) bodyFormData.set('category_path', data.category_path);

        bodyFormData.set('code', data.code );
        bodyFormData.set('ends_at', data.end_date);
        bodyFormData.set('is_active', data.is_active ? true : false);

        if(data._id) {
            url = `coupons/` + data._id
            try {
                const coupon = await axiosInstance.put(url, data);
                return coupon.data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const coupon = await axiosInstance.post(url, data);
                return coupon.data;
            } catch (error) {
                throw error;
            }
        }
    }
};

export default actions;
